// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Ya574","input":"styles_input__fmfWQ","photoContainer":"styles_photoContainer__rEOyR","image":"styles_image__sZWHV"};